





































import { createComponent, watch, ref } from "@vue/composition-api";
import { BasePrimaryButton } from "@web-components";
import SliderPanel from "@dcc/components/SliderPanel.vue";
import DrinkFreeDaysPanel from "@dcc/components/DrinkFreeDaysPanel.vue";
import WeeklyDailyUnitsPanel from "@dcc/components/WeeklyDailyUnitsPanel.vue";
import DrinkerResults from "@dcc/components/DrinkerResults.vue";
import { findGetters as findScoreGetters } from "@dcc/store/score/getters";
import { useDrinkFreeDays } from "@dcc/views/compositions/useDrinkFreeDays";
import { useSlider } from "@dcc/views/compositions/useSlider";
import { getRiskText } from "@dcc/constants/riskLevels";
//eslint-disable-next-line
import { RiskLevel } from "@dcc/types/riskLevel";
import { getActions } from "../store/activity/actions";
import { getActions as getScoreActions } from "@dcc/store/score/actions";
import { useDictionary } from "@dcc/views/compositions/useDictionary";
import { SHOW_TIPS_LINK } from "@dcc/constants/links";

export default createComponent({
  components: {
    SliderPanel,
    DrinkFreeDaysPanel,
    BasePrimaryButton,
    WeeklyDailyUnitsPanel,
    DrinkerResults
  },
  setup(props: {}, context) {
    const drinkFreeDaysObj = useDrinkFreeDays(context);
    const sliderObj = useSlider(context);
    const dictionary = useDictionary();

    const showActionPlan = ref(false);

    const {
      getCaloriesAndUnitsForEachDay,
      getIsBingeDrinker
    } = findScoreGetters(context.root.$store);
    const isBingeDrinker = getIsBingeDrinker();
    const unitsAndCaloriesPerDay = getCaloriesAndUnitsForEachDay();
    const showDailyUnits = !sliderObj.showSlider;

    const { fetchActivities } = getActions(context.root.$store);
    fetchActivities();
    const { trackShowMeHowClicked, trackShowMeTipsClicked } = getScoreActions(
      context.root.$store
    );

    watch(
      () => drinkFreeDaysObj.localDrinkFreeDays.value,
      drinkFreeDays => {
        if (drinkFreeDays.length === 0) {
          showActionPlan.value = false;
        }
      }
    );

    watch(
      () => sliderObj.sliderPercentage.value,
      slider => {
        if (showActionPlan.value && slider === sliderObj.initialPercentage) {
          showActionPlan.value = false;
        }
      }
    );

    const { weeklyRiskLowTipTitle, weeklyRiskLowTipDescription } = getRiskText(
      isBingeDrinker.value
    );

    const handleShowMeHow = () => {
      showActionPlan.value = true;
      trackShowMeHowClicked();
    };

    const handleShowMeTips = () => {
      showActionPlan.value = true;
      trackShowMeTipsClicked();
    };

    return {
      ...drinkFreeDaysObj,
      ...sliderObj,
      unitsAndCaloriesPerDay,
      showDailyUnits,
      showActionPlan,
      weeklyRiskLowTipTitle,
      weeklyRiskLowTipDescription,
      RiskLevel,
      handleShowMeHow,
      handleShowMeTips,
      ...dictionary,
      SHOW_TIPS_LINK
    };
  }
});
